// Monitor-with-charts dashboard glyph (pie chart + ascending bars on a screen).
// Drop-in replacement for a lucide icon: accepts className/style, uses
// currentColor so nav active/hover colors drive it.
export function DashboardMonitorIcon({ className, style, strokeWidth = 2, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
      aria-hidden="true"
      {...props}
    >
      {/* Monitor screen + stand */}
      <rect x="2" y="3" width="20" height="14" rx="2" />
      <path d="M9 21h6" />
      <path d="M12 17v4" />
      {/* Pie chart (left) */}
      <circle cx="7.6" cy="10" r="2.9" />
      <path d="M7.6 10V7.1" />
      <path d="M7.6 10l2.7 1" />
      {/* Ascending bar chart (right) */}
      <path d="M13.4 13.3V11" />
      <path d="M16 13.3V9.4" />
      <path d="M18.6 13.3V7.8" />
    </svg>
  );
}

export default DashboardMonitorIcon;
